import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Features from "./components/Features";
import ClassSystem from "./components/ClassSystem";
import Results from "./components/Results";
import ConsultCTA from "./components/ConsultCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Features />
      <ClassSystem />
      <Results />
      <ConsultCTA />
    </>
  );
}